import { balanceOf, } from "@bracket/contractor-next/brktETH";
import { brktToUsd, } from "@store/commons";
import { wagmiConfig as config } from "@wagmiconfig";
import { getAccount, } from "wagmi/actions";
import { gql, } from "./loaders";

export const getPlatform = async (  ) => {

	try {

		const { address, } = getAccount(config);
		if(!address) {
			throw new Error("wallet does not have an address set");
		}
		const [
			R,
			balance,
		] = await Promise.all([
			gql("PLATFORM_MASTER"),
			balanceOf({ address, config, }),
		]);

		if("platform_data" in R) {

			const {
				claimr_points,
				platform_tvl,
				total_holdings,
				brkt_1d,
				brkt_3d,
				brkt_7d,
				brkt_14d,
				brkt_21d,
				brkt_28d,
			} = R.platform_data;

			const total_value_brkt = balance - BigInt(total_holdings.brkt.split(".")[0]);

			const result = Object.assign(R, {
				claimr_points,
				platform_tvl,
				total_value: {
					brkt: Number(total_value_brkt).toString(),
					usd: await brktToUsd(total_value_brkt),
				},
				brkt_1d,
				brkt_3d,
				brkt_7d,
				brkt_14d,
				brkt_21d,
				brkt_28d,
			});

			return result;
		}

		throw new Error("platform data failed to load.");

	}
	catch(err) {

		console.warn(`Failed gaining platform data - ${err instanceof Error ? err.message : "unknown error"}`);

		return {
			claimr_points: 0,
			platform_tvl: 0,
		}
	}
}
